module.exports = __webpack_public_path__ + "images/c2a81ec9e0f7928ee424072c5e2d4fff-staying-pic-odisha.png";